import api from "../../../config/api/index.js";
import type { ApiResponse } from "../requestLoan/types.js";
import type {
  AddCustomerForInsuranceRememberPayload,
  getCusomterType,
} from "./types.js";

// ============================================================
// مشتری
// ============================================================

/**
 * دریافت لیست مشتریان (visitor)
 */
export const GetCustomersFn = async ({
  page = 0,
  size = 25,
  sortField = "id",
  sortDirection = "ASC",
  search = "",
}: getCusomterType): Promise<ApiResponse> => {
  try {
    const response = await api.post<ApiResponse>(
      `/customerPanel/visitor/searchCustomersForVisitor?search=${search}&page=${page}&size=${size}&sortField=${sortField}&sortDirection=${sortDirection}`,
      "dsd"
    );
    return response.data;
  } catch (error) {
    console.error("Failed to getCustomer:", error);
    throw error;
  }
};
// src/core/api/customer/revenues/importCustomerExcel/api.ts
/**
 * دریافت گزارش معدل حساب بازاریاب (همه رکوردها)
 * @returns پاسخ سرور
 */
export const GetAllAverageVisitorApi = async (): Promise<any> => {
  try {
    const response = await api.get(
      "customerPanel/login/getAllAverageVisitor"
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to get all average visitor:", error);
  }
};
// core/services/auth/api.ts
/**
 * دریافت گزارش معدل حساب مشتری (همه رکوردها)
 * @returns پاسخ سرور
 */
export const GetAllAverageCustomerApi = async (): Promise<any> => {
  try {
    const response = await api.get(
      "customerPanel/login/getAllAverageCustomer"
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to get all average customer:", error);
    throw error;
  }
};
export const ImportCustomerWithExcel = async (
  file: File,
  streetPlanId1: number,
  streetPlanId2?: number | null,
  streetPlanId3?: number | null
): Promise<Blob> => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await api.post(
    "/customerPanel/visitor/importCustomerWithExcel",
    formData,
    {
      params: {
        streetPlanId1,
        ...(streetPlanId2 ? { streetPlanId2 } : {}),
        ...(streetPlanId3 ? { streetPlanId3 } : {}),
      },
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/octet-stream",
      },
    }
  );

  return res.data;
};
/**
 * دریافت اطلاعات مشتری بر اساس شماره موبایل
 */
export const GetCustomerInfo = async (mobile: number): Promise<ApiResponse> => {
  try {
    const response = await api.get<ApiResponse>(
      `/customerPanel/visitor/getDetailOfCustomer?mobileNumber=${mobile}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to getCustomer info:", error);
    throw error;
  }
};

/**
 * ثبت شماره شبا مشتری
 */
export const setShebaCustomer = async (data: { shebaNumber: string }) => {
  try {
    const res = await api.post(`/customerPanel/login/setSheba`, {
      shebaNumber: data.shebaNumber,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

/**
 * افزودن مشتری برای بیمه یادآور
 */
export const AddCustomerForInsuranceRemember = async (
  payload: AddCustomerForInsuranceRememberPayload
) => {
  try {
    const res = await api.post(
      "/customerPanel/visitor/addCustomerForInsuranceRemember",
      payload
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

/**
 * دریافت پلن‌های مشتری (visitor)
 */
export const GetPlaneCustomer = async () => {
  try {
    const res = await api.get("customerPanel/visitor/getAllVisitorPlans");
    return res.data;
  } catch (err) {
    throw err;
  }
};

/**
 * دریافت پلن‌های مشتری
 */
export const GetPlaneCustomerTest = async () => {
  try {
    const res = await api.get(
      "customerPanel/customer/streetPlan/getPlansCustomer"
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

/**
 * ایجاد مشتری برای استریت‌کارت
 */
export const CreateCustomerForStreetCard = async (datas: any) => {
  try {
    const res = await api.post(
      "customerPanel/visitor/addCustomerForStreetCard",
      datas
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

// ============================================================
// ثبت‌نام حقوقی / خیریه
// ============================================================

export const RequestRegisterLegal = async (payload: any) => {
  try {
    const res = await api.post(
      "/customerPanel/visitor/requestRegisterLegal",
      payload
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const RequestRegisterCharity = async (payload: any) => {
  try {
    const res = await api.post(
      "/customerPanel/visitor/requestRegisterCharity",
      payload
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

// ============================================================
// لیست مشتریان visitor
// ============================================================

interface GetCustomersListVisitorParams {
  page: number;
  size: number;
  search?: string;
  sortField?: string;
  sortDirection?: "ASC" | "DESC";
}

export const GetCustomersListVisitor = async ({
  page,
  size,
  search = "",
  sortField = "id",
  sortDirection = "ASC",
}: GetCustomersListVisitorParams) => {
  try {
    const url = `customerPanel/visitor/searchCustomersForVisitor?page=${page}&size=${size}&sortField=${sortField}&sortDirection=${sortDirection}${search ? `&search=${encodeURIComponent(search)}` : ""
      }`;


    const res = await api.get(url);
    return res.data;
  } catch (err) {
    console.error("❌ خطا در دریافت مشتریان:", err);
    throw err;
  }
};

// ============================================================
// لیست درخواست‌های ثبت مشتری (حقوقی/خیریه)
// ============================================================

export const GetVisitorRequests = async ({
  status = "NEW",
  page = 0,
  size = 25,
  sortField = "id",
  sortDirection = "ASC",
}: {
  status?: "ALL" | "NEW" | "APPROVED" | "REJECTED" | "PENDING";
  page?: number;
  size?: number;
  sortField?: string;
  sortDirection?: "ASC" | "DESC";
} = {}) => {
  try {
    const url = `customerPanel/visitor/search?status=${status}&page=${page}&size=${size}&sortField=${sortField}&sortDirection=${sortDirection}`;
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    console.error("❌ خطا در دریافت درخواست‌ها:", err);
    throw err;
  }
};

// ============================================================
// طرح پیش‌فرض
// ============================================================

/**
 * انتخاب طرح پیش‌فرض برای مشتری
 */
export const SetDefaultPlanForVisitorApi = async (planId: number) => {
  const response = await api.get(
    "customerPanel/customer/streetPlan/setDefaultStreetPlanForCustomer",
    { params: { planId } }
  );
  return response.data;
};

/**
 * انتخاب طرح پیش‌فرض برای بازاریاب
 */
export const SetDefaultPlanVisitorApi = async (streetPlanId: number) => {
  const response = await api.get(
    "customerPanel/visitor/setDefaultPlanForVisitor",
    { params: { streetPlanId } }
  );
  return response.data;
};

// ============================================================
// الماس
// ============================================================

export const GetActiveDiamondValue = async () => {
  try {
    const res = await api.get("/customerPanel/data/getAllActiveDiamondValue");
    return res.data;
  } catch (err) {
    throw err;
  }
};

// ============================================================
// طرح‌های مشتری
// ============================================================

export const GetPlanForCustomer = async (customerId: number) => {
  try {
    const res = await api.get(
      `/customerPanel/visitor/getPlanForCustomer?customerId=${customerId}`
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const ChangePlanForCustomer = async (payload: {
  customerId: number;
  streetPlanId1: number;
  streetPlanId2?: number;
  streetPlanId3?: number;
}) => {
  try {
    const res = await api.post(
      `/customerPanel/visitor/changePlanForCustomer`,
      payload
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

// ============================================================
// گزارش عملکرد
// ============================================================

export const GetVisitorPerformance = async ({
  page = 0,
  size = 25,
  sortField = "id",
  sortDirection = "ASC",
}: {
  page?: number;
  size?: number;
  sortField?: string;
  sortDirection?: "ASC" | "DESC";
} = {}) => {
  try {
    const url = `customerPanel/visitor/visitorPerformance?page=${page}&size=${size}&sortField=${sortField}&sortDirection=${sortDirection}`;
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    console.error("❌ خطا در دریافت گزارش عملکرد:", err);
    throw err;
  }
};

export const GetCustomerPerformance = async ({
  page = 0,
  size = 25,
  sortField = "id",
  sortDirection = "ASC",
}: {
  page?: number;
  size?: number;
  sortField?: string;
  sortDirection?: "ASC" | "DESC";
} = {}) => {
  try {
    const url = `customerPanel/login/CustomerPerformance?page=${page}&size=${size}&sortField=${sortField}&sortDirection=${sortDirection}`;
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    console.error("❌ خطا در دریافت گزارش عملکرد مشتری:", err);
    throw err;
  }
};

// ============================================================
// جزئیات مشتری
// ============================================================

export const GetCustomerDetailForVisitor = async (customerId: number) => {
  try {
    const res = await api.get(
      `/customerPanel/visitor/findByCustomerId?customerId=${customerId}`
    );
    return res.data;
  } catch (err) {
    console.error("❌ خطا در دریافت جزییات مشتری:", err);
    throw err;
  }
};